import { version } from "./version";

export const environment = {
  URL_WEB:"https://web.boneva.liberasoft.cloud/",
  production: false,
  apiUrl:"https://api.boneva.liberasoft.cloud/b2b/",
  filesUrl:"https://api.boneva.liberasoft.cloud/files/",
  dateBuild: version.dateBuild,
  Version: version.Version,
  MODE:"B2C"
};
